<template>
  <div>
    <PublishVersion
      :service="lastVersion.service_class"
      :submitting="submitting"
      @submit="submitVersion"
    />
    <drop-zones
      :selected-drop-zones="version.settings.drop_zones"
      :zones="zones"
      :service="lastVersion.service_class"
      @drop-zones="version.settings.drop_zones = $event"
    />

    <b-card>
      <validation-observer ref="versionFormRef">
        <b-form
          autocomplete="off"
          novalidate
          @submit.prevent="submitVersion"
        >
          <div class="d-flex justify-content-end align-items-center mb-1">
            <b-button
              v-if="isNew"
              variant="primary"
              :disabled="isPublished"
              @click="openPublishModal"
            >
              Submit Version
            </b-button>
          </div>
          <b-row>
            <b-col
              v-if="isNew"
              md="4"
            >
              <b-button
                variant="info"
                @click="testPricingHandler"
              >
                Test Pricing {{ openTestPricing ? 'Again': '' }}
              </b-button>
            </b-col>
            <b-col md="12">
              <test-version
                v-if="openTestPricing"
                ref="testVersionRef"
                :version-settings="version.settings"
                :current-zone="version.zone"
                :service="lastVersion.service_class"
              />
            </b-col>
          </b-row>
          <b-tabs>
            <b-tab title="General Section">
              <b-row>
                <b-col md="4">
                  <validation-provider
                    name="Effective Date Time"
                    rules="required"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      label="Effective Date Time"
                      label-for="effective-time"
                    >
                      <flat-pickr
                        v-model="version.effective_date_time"
                        :disabled="!isNew"
                        class="form-control"
                        :config="{ enableTime: true}"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col
                  md="8"
                  class="d-flex align-items-center justify-content-end"
                >
                  <b-button
                    class="mr-1"
                    variant="success"
                    @click="$bvModal.show(`add-drop-zones-${lastVersion.service_class}`)"
                  >
                    Drop Zones
                  </b-button>

                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Time Frames Slicings">
              <TimeFrameSlices
                :slices="version.settings.time_frame_slices"
                
                @time-frame-slices-set="version.settings.time_frame_slices = $event"
              />
            </b-tab>
            <b-tab title="Default Slicings">
              <b-row>
                <b-col md="6">
                  <slicings
                    :slicings="version.settings.time_slicings"
                    @time-slices="version.settings.time_slicings = $event"
                  />
                </b-col>
                <b-col md="6">
                  <slicings
                    slices-type="distance"
                    :slicings="version.settings.distance_slicings"
                    @distance-slices="version.settings.distance_slicings = $event"
                  />
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Journey Wait Time">
              <b-row>
                <b-col md="12">
                  <slicings
                    slices-type="waiting"
                    :slicings="version.settings.journey_wait_time"
                    @waiting-slices="version.settings.journey_wait_time = $event"
                  />
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Upfront Estimates">
              <b-row>
                <b-col md="12">
                  <b-form-checkbox
                    v-model="version.settings.upfront_estimates.active"
                    switch
                  >
                    Active
                  </b-form-checkbox>
                </b-col>
                <b-col md="5">
                  <h4>Distance</h4>
                  <validation-provider
                    name="Minimum Distance Threshold"
                    :rules="version.settings.upfront_estimates.active ? 'required' : ''"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      label="Minimum Distance Threshold"
                      label-for="minimum-distance-threshold"
                    >
                      <b-form-input
                        id="minimum-distance-threshold"
                        v-model.number="version.settings.upfront_estimates.minimum_distance_threshold"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>
                  <b-form-group
                    label="Rate"
                    label-for="upfront-estimates-rate"
                  >
                    <b-form-radio-group
                      id="upfront-estimates-rate"
                      v-model="version.settings.upfront_estimates.distance.rate"
                      :options="rateOptions"
                    />
                  </b-form-group>

                  <validation-provider
                    :name="`Minimum ${distanceLabeling}`"
                    :rules="version.settings.upfront_estimates.active ? 'required' : ''"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      :label="`Minimum ${distanceLabeling}`"
                      label-for="minimum-upfront-distance"
                    >
                      <b-form-input
                        id="minimum-upfront-distance"
                        v-model.number="version.settings.upfront_estimates.distance.minimum"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                    :name="`Maximum ${distanceLabeling}`"
                    :rules="version.settings.upfront_estimates.active ? 'required' : ''"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      :label="`Maximum ${distanceLabeling}`"
                      label-for="maximum-upfront-distance"
                    >
                      <b-form-input
                        id="maximum-upfront-distance"
                        v-model.number="version.settings.upfront_estimates.distance.maximum"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>
                </b-col>
                <hr>
                <b-col
                  md="2"
                  class="d-flex justify-content-center"
                >
                  <div class="vertical-line" />
                </b-col>
                <b-col md="5">
                  <h4>Time</h4>
                  <!-- Dummy div to inline inputs with each other -->
                  <div style="height:75px" />
                  <b-form-group
                    label="Rate"
                    label-for="upfront-estimates-rate-time"
                  >
                    <b-form-radio-group
                      id="upfront-estimates-rate-time"
                      v-model="version.settings.upfront_estimates.time.rate"
                      :options="rateOptions"
                    />
                  </b-form-group>
                  <validation-provider
                    :name="`Minimum ${timeLabeling}`"
                    :rules="version.settings.upfront_estimates.active ? 'required' : ''"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      :label="`Minimum ${timeLabeling}`"
                      label-for="minimum-upfront-time"
                    >
                      <b-form-input
                        id="minimum-upfront-time"
                        v-model.number="version.settings.upfront_estimates.time.minimum"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                    :name="`Maximum ${timeLabeling}`"
                    :rules="version.settings.upfront_estimates.active ? 'required' : ''"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      :label="`Maximum ${timeLabeling}`"
                      label-for="maximum-upfront-time"
                    >
                      <b-form-input
                        id="maximum-upfront-time"
                        v-model.number="version.settings.upfront_estimates.time.maximum"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Advanced Section">
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="General Section"
                  />
                </b-col>
                <b-col md="6">
                  <validation-provider
                    name="Minmum Amount"
                    rules="required"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      label-for="minimum-amount"
                    >
                      <template #label>
                        <span>Minmum Amount</span>
                        <b-button
                          class="btn-icon rounded-circle"
                          variant="flat-primary"
                          @click="allowEditingGeneralSection.minAmount = false"
                        >
                          <feather-icon
                            icon="EditIcon"
                          />
                        </b-button>

                      </template>
                      <b-form-input
                        id="minimum-amount"
                        v-model.number="version.settings.minimum_amount"
                        :disabled="allowEditingGeneralSection.minAmount"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                    name="Admin Commission"
                    rules="required"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      label-for="admin-commission"
                    >
                      <template #label>
                        <span>Admin Commission</span>
                        <b-button
                          class="btn-icon rounded-circle"
                          variant="flat-primary"
                          @click="allowEditingGeneralSection.adminCommission = false"
                        >
                          <feather-icon
                            icon="EditIcon"
                          />
                        </b-button>

                      </template>
                      <b-form-input
                        id="admin-commission"
                        v-model.number="version.settings.admin_commission"
                        :disabled="allowEditingGeneralSection.adminCommission"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    name="Open Meter Amount"
                    rules="required"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      label-for="open-meter-amount"
                    >
                      <template #label>
                        <span>Open Meter Amount</span>
                        <b-button
                          class="btn-icon rounded-circle"
                          variant="flat-primary"
                          @click="allowEditingGeneralSection.openAmount = false"
                        >
                          <feather-icon
                            icon="EditIcon"
                          />
                        </b-button>

                      </template>
                      <b-form-input
                        id="open-meter-amount"
                        v-model.number="version.settings.open_meter_amount"
                        :disabled="allowEditingGeneralSection.openAmount"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                    name="Tax Amount"
                    rules="required"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      label-for="tax-amount"
                    >
                      <template #label>
                        <span>Tax Amount</span>
                        <b-button
                          class="btn-icon rounded-circle"
                          variant="flat-primary"
                          @click="allowEditingGeneralSection.taxAmount = false"
                        >
                          <feather-icon
                            icon="EditIcon"
                          />
                        </b-button>

                      </template>
                      <b-form-input
                        id="tax-amount"
                        v-model.number="version.settings.tax_amount"
                        :disabled="allowEditingGeneralSection.taxAmount"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>

                </b-col>

                <b-col md="12">
                  <b-form-group label="Estimates Price Section" />
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Rate"
                    label-for="estimates-rate"
                  >
                    <b-form-radio-group
                      id="estimates-rate"
                      v-model="version.settings.estimates.rate"
                      :options="rateOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <validation-provider
                    name="Rate Value"
                    rules="required"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      label="Rate Value"
                      label-for="rate-value"
                    >
                      <b-form-input
                        id="rate-value"
                        v-model.number="version.settings.estimates.value"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="3">
                  <b-form-group
                    label="Upper Rate Value"
                    label-for="upper-rate-value"
                  >
                    <b-form-input
                      id="upper-rate-value"
                      v-model.number="version.settings.estimates.value_upper"
                      type="number"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Arrival Section" />
                </b-col>
                <b-col md="6">
                  <validation-provider
                    name="Amount Per minute"
                    rules="required"
                  >
                    <b-form-group
                      slot-scope="{ errors }"
                      label="Amount Per minute"
                      label-for="arrival-amount-per-minute"
                    >
                      <b-form-input
                        id="arrival-amount-per-minute"
                        v-model.number="version.settings.arrival.amount_per_minute"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>

                </b-col>
                <b-col md="6">
                  <validation-provider
                    name="Free Waiting Time"
                    rules="required"
                  >
                    <b-form-group
                      slot-scope="{ errors }"

                      label="Free Waiting Time"
                      label-for="arrival-free-waiting-time"
                    >
                      <b-form-input
                        id="arrival-free-waiting-time"
                        v-model.number="version.settings.arrival.free_waiting_time"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>

                </b-col>
                <!--  -->
                <b-col md="6">
                  <validation-provider
                    name="Maximum Time threshold"
                    rules="required"
                  >
                    <b-form-group
                      slot-scope="{ errors }"

                      label="Maximum Time threshold"
                      label-for="arrival-max-time-threshold"
                    >
                      <b-form-input
                        id="arrival-max-time-threshold"
                        v-model.number="version.settings.arrival.maximum_time_threshold"
                        type="number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Session Discount Slices">
              <SessionDiscountSlices
                :slicings="version.settings.session_discount_slices"
                @session-slices="version.settings.session_discount_slices = $event"
              />
            </b-tab>
            <b-tab title="Delay discounts">
              <DelayDiscount
                :delay-discount-message="version.settings.delay_discount_message"
                :delay-discount-enabled="version.settings.delay_discount_enabled"
                @input="version.settings.delay_discount_enabled = $event.delay_discount_enabled;version.settings.delay_discount_message = $event.delay_discount_message;"
              />
            </b-tab>
          </b-tabs>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>
<script>
import { required } from '@validations'
import {
  BCard, BFormGroup, BFormInput, BRow, BCol, BFormRadioGroup, BButton, VBModal, BForm, BFormCheckbox, BTabs, BTab,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import { reactive, ref } from '@vue/composition-api'
import useVersionForm from '../../hooks/useVersionForm'
import DropZones from './DropZones.vue'
import Slicings from './Slicings.vue'
import TestVersion from './TestVersion.vue'
import TimeFrameSlices from './TimeFrameSlices.vue'
import PublishVersion from './PublishVersion.vue'
import SessionDiscountSlices from './SessionDiscountSlices.vue'
import DelayDiscount from './DelayDiscount.vue'

export default {
  components: {
    DropZones,
    Slicings,
    TimeFrameSlices,
    DelayDiscount,
    BForm,
    BCard,
    BFormGroup,
    SessionDiscountSlices,
    PublishVersion,
    BFormInput,
    BTabs,
    BTab,
    BRow,
    BCol,
    BFormCheckbox,
    BFormRadioGroup,
    flatPickr,
    BButton,
    ValidationObserver,
    ValidationProvider,
    TestVersion,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    lastVersion: {
      type: Object,
      required: true,
    },
    zones: {
      type: Object,
      default: () => ({}),
    },
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    const openTestPricing = ref(false)
    const allowEditingGeneralSection = reactive({
      minAmount: true,
      openAmount: true,
      adminCommission: true,
      taxAmount: true,
    })
    const testPricingHandler = () => {
      openTestPricing.value = true
      setTimeout(() => {
        ctx.refs.testVersionRef.applyTests()
      }, 0)
    }
    return {
      ...useVersionForm(props, ctx),
      openTestPricing,
      testPricingHandler,
      required,
      allowEditingGeneralSection,
    }
  },
}

</script>
